import { Component } from '@angular/core';

@Component({
  selector: 'i-cross',
  imports: [],
  templateUrl: './i-cross.html',
  host: {
    class: 'grid place-items-center',
  },
})
export class ICross {}
